<template>
	<div class="volunteer-home-online-training">
		<div class="online-training-box">
			<ssTrainList :finish="finish_" :busy="busy_" :value="curData_" detailPath="/volunteerHome/onlineTraining/" />
		</div>
		<ssNavigation v-if="pageTotal_ > pageSize" :total="pageTotal_" v-model="curPage" :size="pageSize" />
	</div>
</template>

<script>
	import ssTrainList from '@/components/ss-train-list/ss-train-list.vue'
	import listMixin from '@/mixins/list.js'
	export default {
		mixins: [ listMixin ],
		components: {
			ssTrainList
		},
		data() {
			return {
				typeList: [{
					label: '在线培训',
					value: 'zxpx'
				}]
			}
		}
	}
</script>

<style lang="scss" scoped="scoped">
	.volunteer-home-online-training{
		.online-training-box{
			background-color: #fff;
			padding: 30px 35px;
			::v-deep .train-list{
				padding-right: 60px;
				.train-item{
					margin-right: 30px;
					width: 33.33333333%;
					&:nth-of-type(4n) {
						float: left;
						margin-right: 30px;
					}
					&:nth-of-type(3n) {
						float: right;
						margin-right: -60px;
					}
				}
			}
		}
	}
</style>
